/**
 * Checks if the element's scroll is reached the bottom
 * @param element
 */
export const isBottom = (element: HTMLElement) => {
    return Math.ceil(element.scrollTop + element.clientHeight )>= element.scrollHeight;
}
